export default {
  inactive_doctor: 'Inactive Doctor',
  inactive_clinic: 'Inactive Clinic',
  doctors: 'doctors',
  clinic_examine: 'clinic examine',
  outdoor_examine: 'outdoor examine',
  clinics: 'clinics',
  hospitals: 'hospitals'
}
